import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Nextcloud = (props: TIconProps): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="hsl(from hsl(199 100% 39%) h s 50%)"
    {...props}
  >
    <path d="M12 6.104a5.91 5.91 0 0 0-5.66 4.222 3.588 3.588 0 0 0-2.784-1.36A3.56 3.56 0 0 0 0 12.52a3.56 3.56 0 0 0 3.556 3.555 3.588 3.588 0 0 0 2.785-1.36A5.91 5.91 0 0 0 12 18.937a5.91 5.91 0 0 0 5.659-4.221 3.588 3.588 0 0 0 2.785 1.36A3.56 3.56 0 0 0 24 12.52a3.56 3.56 0 0 0-3.556-3.554 3.588 3.588 0 0 0-2.785 1.36A5.91 5.91 0 0 0 12 6.104zm0 2.223a4.174 4.174 0 0 1 4.193 4.193A4.174 4.174 0 0 1 12 16.713a4.174 4.174 0 0 1-4.193-4.193A4.174 4.174 0 0 1 12 8.327zm-8.444 2.862c.75 0 1.332.582 1.332 1.331 0 .75-.583 1.332-1.332 1.332a1.312 1.312 0 0 1-1.333-1.332c0-.749.583-1.331 1.333-1.331zm16.888 0c.75 0 1.333.582 1.333 1.331 0 .75-.584 1.332-1.333 1.332a1.312 1.312 0 0 1-1.332-1.332c0-.749.583-1.331 1.332-1.331z" />
  </svg>
);
